import { createSlice } from '@reduxjs/toolkit';
import { createSelector } from '@reduxjs/toolkit';

export const presenceSlice = createSlice({
    name: 'presence',
    initialState: {
        presenceMap: {}, // Map of user -> presence status
        selfPresence: 'open'
    },
    reducers: {
        setUserPresence: (state, action) => {
            state.presenceMap[action.payload.user] = action.payload.presence;
        },
        setSelfPresence: (state, action) => {
            state.selfPresence = action.payload;
        },
        setBulkPresence: (state, action) => {
            state.presenceMap = { ...state.presenceMap, ...action.payload };
        }
    }
});

export const { setUserPresence, setSelfPresence, setBulkPresence } = presenceSlice.actions;

// Memoized selector for getting a user's presence
export const selectUserPresence = createSelector(
    [(state) => state.presence.presenceMap, (_, user) => user],
    (presenceMap, user) => presenceMap[user] || null
);

export const selectSelfPresence = (state) => state.presence.selfPresence;

export default presenceSlice.reducer;